import React from 'react';
import { AnalyticsTableCellValueFormat } from '../../AnalyticsTableCellValueFormat/AnalyticsTableCellValueFormat';
import * as S from './TableCellBreakdown.styled';
export const TableCellBreakdown = ({ title, items, type }) => {
    return (React.createElement(S.Container, null,
        title && React.createElement(S.Title, null, title),
        React.createElement(S.Content, null,
            React.createElement(S.Column, null, items.map(({ label }) => (React.createElement(S.Item, null,
                React.createElement(S.Label, null, label))))),
            React.createElement(S.Column, null, items.map(({ value }) => (React.createElement(S.Item, null,
                React.createElement(S.Value, null,
                    React.createElement(AnalyticsTableCellValueFormat, { type: type, value: value })))))))));
};
